module.exports = __webpack_public_path__ + "img/8.f57805f1.jpg";